function thxPage() {
  let input = $('.save-order-pictures');

  input.each(function () {
    let saveButton = $(this);
    let alert = saveButton.parent().parent().parent().find('.subject-alert');
    alert.addClass('is-hidden');
    $(this).on('click', function (event) {
      alert.addClass('is-hidden');
      let form = saveButton
        .parent()
        .parent()
        .parent()
        .find('.serialRow')
        .find('form');
      let url = form.attr('action');
      $.ajax({
        type: 'POST',
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function (data, event) {
          alert.addClass('is-hidden');
          saveButton
            .parent()
            .parent()
            .parent()
            .addClass('is-collapsed')
            .addClass('is-success');
          checkAllCollapsed();
        },
        error: function (data) {
          alert.removeClass('is-hidden');
          alert
            .children()
            .children()
            .find('.alert-message')
            .html(data.responseJSON);
        },
      });
    });
  });

  let sendPicturesButton = $('.send-pictures-and-code');
  sendPicturesButton.on('click', function () {
    hideFirstTextAndBoxes();
  });

  let skipPictures = $('.skip-pictures');
  skipPictures.on('click', function () {
    hideFirstTextAndBoxes();
  });
}

function checkAllCollapsed() {
  let thxBox = $('.thx__box');
  let allChecked = false;
  thxBox.each(function () {
    if ($(this).hasClass('is-collapsed')) {
      allChecked = true;
    } else {
      allChecked = false;
    }
  });
  if (allChecked === true) {
    $('.skip-pictures').addClass('is-hidden');
    $('.send-pictures-and-code').removeClass('is-hidden');
  }
}

function hideFirstTextAndBoxes() {
  $('.thx-top-first').addClass('is-hidden');
  $('.thx__content').addClass('is-hidden');
  $('.thx-bottom-first').addClass('is-hidden');
  $('.thx-top-last').removeClass('is-hidden');
  $('.thx-bottom-last').removeClass('is-hidden');
  $('.showFirstButton').addClass('is-hidden');
  $('.showLastButton').removeClass('is-hidden');
  setTimeout(function () {
    window.location.href = $('.showLastButton').find('a').attr('href');
  }, 20000);
}
